import {Ticker} from '@theatre/dataverse'

const studioTicker = Ticker.raf

export default studioTicker
